import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {TradingAlert} from "../models/alert/TradingAlert";
import {AlertViewDialog} from "../components/alert-dialog/view-dialog/AlertDialogComponent";

export class TradingAlertViewDialogService {

    public static id = "tradingAlertViewDialogService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public async open(alert: TradingAlert): Promise<void> {
        const options: IModalSettings = {
            component: AlertViewDialog,
            size: "md",
            windowClass: "fixed-height-modal",
            resolve: {
                alert: () => alert
            }
        };
        const alertModal = this.$uibModal.open(options);
        return await alertModal.result;
    }
}
